import { useMemo } from 'react'

import {KTSVG} from '../../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'

import * as Yup from 'yup'
import {useFormik} from 'formik'

import { useQueryResponseLoading } from '../../core/QueryResponseProvider'
import { useDLMLabelSetsQueryResponseData } from '../../../../core/doclabel'

import { orderBy, filter, pickBy } from 'lodash'

interface ISearchLabelRequestModel{
  label: string
  labelSearchId: number
}


const searchLabelSchema: any = Yup.object({        
  label: Yup.string().trim().label('Label'),                    
  labelSearchId: Yup.number().integer().label('Label Set ID')
});

const initValues: ISearchLabelRequestModel = {
  label: '',
  labelSearchId: 0,
}

const TYPE_FIELDS = [
  'id',
  'name'
];

const LabelsListSearchComponent = () => {
  const labelSets = useDLMLabelSetsQueryResponseData();
  const typeOptions = useMemo(() => orderBy(filter(labelSets, o => (! o?.deleted)), ['name'], ['asc']).map(item => pickBy(item, (value,key) => (TYPE_FIELDS.indexOf(key) > -1)))
  , [labelSets]);

  const {updateState} = useQueryRequest()
  const isLoading = useQueryResponseLoading(); 

  const formik = useFormik({
    initialValues: initValues,
    validationSchema: searchLabelSchema,
    enableReinitialize: true,
    onSubmit: (values, {setSubmitting}) => {                             
      setSubmitting(true);
      try{
        updateState({filter : values})
      } 
      catch (e) { 
        console.error(e);
      } 
      finally {
        setSubmitting(false);
      }            
    }                    
  })

  return (
  <>
  <form id='kt_modal_labelsearch_form' className='form' onSubmit={formik.handleSubmit} noValidate>
    <div className="d-flex flex-row flex-wrap align-items-end gap-8 mt-6">
      <div className='w-250px d-flex flex-column justify-content-start align-items-stretch gap-3'>    
        <div className="row">
          <div className="col-4">
            <label className='form-label mt-2 fw-bold mb-0'>Label</label>        
          </div>
          <div className="col-8">
            <input
              type='text'
              className='form-control form-control-sm form-control-solid'                            
              {...formik.getFieldProps('label')}
            />
            {(formik.touched.label && formik.errors.label) && 
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>{formik.errors.label}</div>
            </div>                        
            }
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <label className='form-label mt-2 fw-bold mb-0'>Type</label>        
          </div>
          <div className="col-8">
            <select                            
              className='form-select form-select-sm form-select-solid'
              {...formik.getFieldProps('labelSearchId')}
            >
              <option value='0'></option>
              { (typeOptions && typeOptions.length > 0) &&
              typeOptions.map( (dat: any, idx : number) =>(
              <option key={`dlmtype${dat.id}`} value={`${dat.id}`}>{`${dat.name}`}</option>
              ))
              }             
            </select>
            {(formik.touched.label && formik.errors.label) && 
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>{formik.errors.label}</div>
            </div>                        
            }
          </div>
        </div>
      </div>
      <div>
        <button
          type='submit'
          className='btn btn-primary btn-sm'
          data-kt_modal_labelsearch_form-action='submit'
          disabled={isLoading || !formik.isValid}
        >   
          <KTSVG
            path='/media/icons/duotune/general/gen021.svg'
            className='svg-icon-1'
          />
          <span className='indicator-label'>Search</span>
          {(isLoading) && (
          <span className='indicator-progress'>
            Please wait...{' '}
            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
          </span>
          )}
        </button>                
      </div>
    </div>
  </form>            
  </>
  )
}

export {LabelsListSearchComponent}
